export default __webpack_public_path__ + "static/media/2_tutorial_commonroad_search.a260eba8.png";